/** Central store of data-testid strings. */
export const TID = {
  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error-msg",
  demoAdminBtn: "demo-admin-btn",
  demoBrandBtn: "demo-brand-btn",
  demoOutletBtn: "demo-outlet-btn",
  demoServBtn: "demo-serv-btn",
  demoMfrBtn: "demo-mfr-btn",

  // Layout
  sidebar: "app-sidebar",
  sidebarToggle: "sidebar-toggle-btn",
  themeToggle: "theme-toggle-btn",
  logoutBtn: "logout-btn",
  userMenu: "user-menu-trigger",
  notifBell: "notif-bell-btn",

  // Sidebar links
  navDashboard: "nav-dashboard",
  navBrands: "nav-brands",
  navOutlets: "nav-outlets",
  navAssets: "nav-assets",
  navManufacturers: "nav-manufacturers",
  navSubscriptions: "nav-subscriptions",
  navMaintenance: "nav-maintenance",
  navWarranty: "nav-warranty",
  navUsers: "nav-users",
  navReports: "nav-reports",
  navNotifications: "nav-notifications",
  navAuditLogs: "nav-audit-logs",
  navSettings: "nav-settings",

  // Common CRUD buttons
  addBtn: "add-btn",
  editBtn: (id) => `edit-btn-${id}`,
  deleteBtn: (id) => `delete-btn-${id}`,
  viewBtn: (id) => `view-btn-${id}`,
  searchInput: "search-input",
  saveBtn: "save-btn",
  cancelBtn: "cancel-btn",
  exportBtn: "export-csv-btn",

  // Dashboard KPIs
  kpiBrands: "kpi-brands",
  kpiOutlets: "kpi-outlets",
  kpiAssets: "kpi-assets",
  kpiMRR: "kpi-mrr",
};
